<ng-container [formGroup]="form">
  <td>
    {{ fetch.ordering }} (#{{fetch.id}})
    @if (fetch.status === FETCH_STATUS.CONTRACT) {
      <span class="label label-primary ng-scope">BESTÄTIGT</span>
    }
    @if (fetch.status === FETCH_STATUS.PRODUCED) {
      <span class="label label-rose ng-scope">PRODUZIERT</span>
    }
    @if (fetch.status === FETCH_STATUS.DELIVERY) {
      <span class="label label-warning ng-scope">GELIEFERT</span>
    }
    @if (fetch.status === FETCH_STATUS.CLEAR) {
      <span class="label label-success ng-scope">ABGERECHNET</span>
    }
    @if (fetch.status === FETCH_STATUS.CONCLUDED_NOT_BILLED) {
      <span
        class="label label-default ng-scope"
        title="ABGESCHLOSSEN / NICHT ABGERECHNET">
        ABGESCHLOSSEN
      </span>
    }
    @if (!fetch.contract_obj && (fetch.status <= FETCH_STATUS.DELIVERY)) {
      <span class="label label-danger ng-scope">AB FEHLT</span>
    }
  </td>
  <td>
    @if (fetch.status >= FETCH_STATUS.CLEAR) {
      {{ fetch.positions[0].quanity }}
    } @else {
      <integer-input formControlName="quantity" [inputSelect]="true" [changeEvent]="false"></integer-input>
    }
  </td>
  <td>{{ fetch.delivery }}</td>
  <td>
    @if ((fetch.status < FETCH_STATUS.DELIVERY) && !fetch.blocked) {
      <delivery-fetch-copy-create [workflowId]="workflowId"
        [fetchId]="fetch.id"
        (reloadList)="reloadList.emit()">
      </delivery-fetch-copy-create>
    }
  </td>
  <td>
    @if (((fetch.status < FETCH_STATUS.DELIVERY) || (fetch.status === FETCH_STATUS.DELIVERY && !newNr)) && !fetch.blocked) {
      <button class="btn btn-xs w-[75px]"
        [ngClass]="{'btn-danger': fetch.use, 'btn-success': !fetch.use}"
        [title]="(fetch.use ? 'Abruf aus Lieferschein entfernen' : 'Abruf zum Lieferschein hinzufügen')"
        (click)="toggle()">
        {{fetch.use ? 'Entfernen' : 'Auswählen'}}
      </button>
    }
  </td>
</ng-container>
